<template src="./NotificationSnackbar.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import { NotificationsGetters } from "@/store/modules/notifications/getters";
import { NotificationsMutation } from "@/store/modules/notifications/mutations";
import { notificationsModule } from "@/store/modules/notifications";

export default defineComponent({
    computed: {
        ...notificationsModule.mapGetters({
            isSnackbarShowing: NotificationsGetters.IsShowing,
            message: NotificationsGetters.NotificationMessage,
            color: NotificationsGetters.Color
        })
    },
    methods: {
        ...notificationsModule.mapMutations({
            setShowing: NotificationsMutation.SetShowing
        })
    }
});
</script>

<style></style>
